import { Bundle } from "@/features/bundles/types";
import { Money } from "@/helpers/Money";

export const bundleDrawerData = [
  {
    title: "Starter Laundry Set",
    discountPercent: 20,
    discountCode: "Starter_Laundry_Set",
    incentive: "Up to $20 off and free shipping",
    image: {
      src: "//cdn.shopify.com/s/files/1/0268/4219/files/Bundles_4-SO_FS_Lav.jpg",
      height: 750,
      width: 750,
    },
    profiles: [
      {
        name: "Refreshing",
        products: [
          "stain-odor-clean-and-crisp-laundry-detergent-pods",
          "clean-scent-booster-with-fabric-softener-pods",
          "laundry-household-oxi-booster-pods-sample-unscented",
        ],
      },
      {
        name: "Calm",
        products: [
          "stain-odor-lavender-eucalyptus-laundry-detergent-pods",
          "lavender-scent-booster-with-fabric-softener-pods",
          "laundry-household-oxi-booster-pods-sample-unscented",
        ],
      },
      {
        name: "Unscented",
        products: [
          "stain-odor-unscented-laundry-detergent-pods",
          "unscented-fabric-softener-pods",
          "laundry-household-oxi-booster-pods-sample-unscented",
        ],
      },
    ],
  },
  {
    title: "Laundry + Kitchen Set",
    discountPercent: 25,
    discountCode: "Laundry_Kitchen_Set",
    incentive: "Up to $33 off and free shipping",
    banner: "Most popular",
    image: {
      src: "//cdn.shopify.com/s/files/1/0268/4219/files/Bundles_1-SO_DD.jpg",
      height: 750,
      width: 750,
    },
    profiles: [
      {
        name: "Refreshing",
        products: [
          "stain-odor-clean-and-crisp-laundry-detergent-pods",
          "clean-scent-booster-with-fabric-softener-pods",
          "laundry-household-oxi-booster-pods-sample-unscented",
          "lemon-dishwasher-detergent-pods",
        ],
      },
      {
        name: "Calm",
        products: [
          "stain-odor-lavender-eucalyptus-laundry-detergent-pods",
          "lavender-scent-booster-with-fabric-softener-pods",
          "laundry-household-oxi-booster-pods-sample-unscented",
          "dishwasher-detergent-pods-fresh-rain",
        ],
      },
      {
        name: "Unscented",
        products: [
          "stain-odor-unscented-laundry-detergent-pods",
          "unscented-fabric-softener-pods",
          "laundry-household-oxi-booster-pods-sample-unscented",
          "unscented-dishwasher-detergent-pods",
        ],
      },
    ],
  },
  {
    title: "Full Household Set",
    discountCode: "Full_Household_Set",
    discountPercent: 35,
    incentive: "Up to $60 off and free shipping",
    banner: "Best value",
    image: {
      src: "//cdn.shopify.com/s/files/1/0268/4219/files/Bundles_3-DD_DS.jpg",
      height: 750,
      width: 750,
    },
    profiles: [
      {
        name: "Refreshing",
        products: [
          "stain-odor-clean-and-crisp-laundry-detergent-pods",
          "clean-scent-booster-with-fabric-softener-pods",
          "oxi-booster-pods",
          "lemon-dishwasher-detergent-pods",
          "power-dish-spray-starter-kit-lemon-verbena",
          "foaming-hand-soap-starter-kit-jasmine-honeysuckle",
        ],
      },
      {
        name: "Calm",
        products: [
          "stain-odor-lavender-eucalyptus-laundry-detergent-pods",
          "lavender-scent-booster-with-fabric-softener-pods",
          "oxi-booster-pods",
          "dishwasher-detergent-pods-fresh-rain",
          "power-dish-spray-starter-kit-fresh-rain",
          "foaming-hand-soap-starter-kit-lavender-chamomile",
        ],
      },
      {
        name: "Unscented",
        products: [
          "stain-odor-unscented-laundry-detergent-pods",
          "unscented-fabric-softener-pods",
          "oxi-booster-pods",
          "unscented-dishwasher-detergent-pods",
          "power-dish-spray-starter-kit-unscented",
          "foaming-hand-soap-starter-kit-unscented",
        ],
      },
    ],
  },
] satisfies Bundle[];
